import { ICertificate } from 'Services/account';
import sessionService from 'Store/module/sessionService';
import moment from "moment";
import { ICertificateState, CertificateState, CertificateContext, NoAuthorizedState, ExpiredState } from './certificateState';

export class AuthorizedState implements ICertificateState {
    getState(): CertificateState {
        return CertificateState.Authorized;
    }


    checkState(context: CertificateContext): void {
        const certificate = sessionService.get() as ICertificate;
        if (!certificate) {
            context.changeState(new NoAuthorizedState());
            return;
        }
        const expired = moment.utc().toDate();
        if (certificate.expired && certificate.expired < expired) {
            context.changeState(new ExpiredState());
            return;
        }
    }
}
